import { Navigate, Outlet } from "react-router";
import { useAppContext } from "@/providers";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export function ProtectedRoute() {
  const { session } = useAppContext();

  if (session.status === "idle" || session.status === "authenticating") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!session.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
